// // @mui material components
// import Drawer from "@mui/material/Drawer";
// import {styled} from "@mui/material/styles";

// export default styled(Drawer)(({theme, ownerState}) => {
//   const {palette, boxShadows, transitions, breakpoints, functions} = theme;
//   const {transparentSidenav, whiteSidenav, miniSidenav, darkMode} = ownerState;

//   const sidebarWidth = 250;
//   const {transparent, gradients, white, background} = palette;
//   const {xxl} = boxShadows;
//   const {pxToRem, linearGradient} = functions;

//   let backgroundValue = darkMode
//     ? background.sidenav
//     : linearGradient(gradients.dark.main, gradients.dark.state);

//   if (transparentSidenav) {
//     backgroundValue = transparent.main;
//   } else if (whiteSidenav) {
//     backgroundValue = white.main;
//   }

//   // styles for the sidenav when miniSidenav={false}
//   const drawerOpenStyles = () => ({
//     background: backgroundValue,
//     transform: "translateX(0)",
//     transition: transitions.create("transform", {
//       easing: transitions.easing.sharp,
//       duration: transitions.duration.shorter
//     }),

//     [breakpoints.down("xl")]: {
//       top: "64px",
//       height: `calc(100vh - 64px)`,
//       position: "absolute",
//       width: sidebarWidth,
//       left: 0,
//       padding: 0,
//       borderRight: "none",
//       marginTop: 0,
//       overflowY: "auto",
//       WebkitOverflowScrolling: "touch"
//     },

//     [breakpoints.up("xl")]: {
//       marginTop: "64px",
//       height: `calc(100vh - 64px)`,
//       position: "fixed",
//       width: sidebarWidth,
//       padding: 0,
//       borderRight: "none",
//       left: 0
//     }
//   });

//   // styles for the sidenav when miniSidenav={true}
//   const drawerCloseStyles = () => ({
//     background: backgroundValue,
//     transform: `translateX(${pxToRem(-320)})`,
//     transition: transitions.create("transform", {
//       easing: transitions.easing.sharp,
//       duration: transitions.duration.shorter
//     }),

//     [breakpoints.down("xl")]: {
//       top: "64px",
//       height: `calc(100vh - 64px)`,
//       position: "absolute",
//       width: sidebarWidth,
//       left: 0,
//       padding: 0,
//       borderRight: "none",
//       marginTop: 0,
//       overflowY: "auto",
//       WebkitOverflowScrolling: "touch"
//     },

//     [breakpoints.up("xl")]: {
//       marginTop: "64px",
//       height: `calc(100vh - 64px)`,
//       position: "fixed",
//       width: sidebarWidth,
//       padding: 0,
//       borderRight: "none",
//       left: 0
//     }
//   });

//   return {
//     "& .MuiDrawer-paper": {
//       boxShadow: xxl,
//       border: "none",
//       overflowX: "hidden",
//       overflowY: "auto",
//       margin: 0,
//       padding: 0,
//       top: 0,
//       left: 0,
//       ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
//       WebkitTapHighlightColor: "transparent !important",
//       touchAction: "pan-y",

//       "& .MuiListItem-root": {
//         width: "100%",
//         color: white.main,
//         "& .MuiListItemIcon-root": {
//           color: white.main + " !important"
//         },
//         "& svg": {
//           color: white.main + " !important"
//         },
//         "& .arrow-icon": {
//           color: white.main
//         }
//       },

//       "& .MuiListItemButton-root": {
//         width: "100% !important",
//         padding: "4px 16px !important",
//         margin: "0 !important",
//         borderRadius: "0 !important",
//         minHeight: "48px !important"
//       },

//       "& .MuiListItem-root:hover": {
//         width: "100%",
//         backgroundColor: "#06acec",
//         color: white.main,
//         "& .MuiListItemIcon-root": {
//           color: white.main + " !important"
//         },
//         "& svg": {
//           color: white.main + " !important"
//         },
//         "& .arrow-icon": {
//           color: white.main
//         }
//       },

//       "& .Mui-selected, & .Mui-selected:hover": {
//         backgroundColor: "#4B0082",
//         color: white.main,
//         "& .MuiListItemIcon-root": {
//           color: white.main + " !important"
//         },
//         "& svg": {
//           color: white.main + " !important"
//         },
//         "& .arrow-icon": {
//           color: white.main
//         }
//       }
//     }
//   };
// });

// @mui material components
import Drawer from "@mui/material/Drawer";
import {styled} from "@mui/material/styles";

export default styled(Drawer)(({theme, ownerState}) => {
  const {palette, transitions, breakpoints, functions} = theme;
  const {transparentSidenav, whiteSidenav, miniSidenav, darkMode} = ownerState;

  const sidebarWidth = 250;
  const {transparent, gradients, white, background} = palette;
  const {pxToRem, linearGradient} = functions;

  let backgroundValue = darkMode
    ? background.sidenav
    : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the sidenav when miniSidenav={false} (open)
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter
    }),

    [breakpoints.up("xl")]: {
      marginTop: "64px",
      height: `calc(100vh - 64px)`,
      position: "fixed",
      width: sidebarWidth,
      padding: 0,
      borderRight: "none",
      left: 0
    }
  });

  // styles for the sidenav when miniSidenav={true} (closed) — desktop only
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter
    }),

    [breakpoints.up("xl")]: {
      marginTop: "64px",
      height: `calc(100vh - 64px)`,
      position: "fixed",
      width: sidebarWidth,
      padding: 0,
      borderRight: "none",
      left: 0
    }
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: "4px 0 24px rgba(24, 54, 122, 0.06)",
      border: "none",
      borderRight: "1px solid rgba(24, 54, 122, 0.08)",
      overflowX: "hidden",
      overflowY: "auto",
      margin: 0,
      padding: "8px 0",
      top: 0,
      left: 0,
      scrollbarWidth: "thin",
      scrollbarColor: "rgba(24, 54, 122, 0.35) transparent",

      "&::-webkit-scrollbar": {
        width: "6px"
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent"
      },
      "&::-webkit-scrollbar-thumb": {
        background: "linear-gradient(180deg, #53B0E0, #18367A)",
        borderRadius: "10px"
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#18367A"
      },
      "&::-webkit-scrollbar-button": {
        display: "none",
        height: 0,
        width: 0
      },

      // ✅ Only apply custom transform on desktop (xl and up)
      // On mobile, let MUI Drawer "temporary" variant handle open/close natively
      [breakpoints.up("xl")]: {
        ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
      },

      // ✅ Mobile styles — no custom transform, MUI handles it
      [breakpoints.down("xl")]: {
        top: "64px",
        height: `calc(100vh - 64px)`,
        position: "fixed",
        width: sidebarWidth,
        padding: "8px 0",
        borderRight: "1px solid rgba(24, 54, 122, 0.08)",
        marginTop: 0,
        background: backgroundValue,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch"
      },

      WebkitTapHighlightColor: "transparent !important",
      touchAction: "pan-y",

      "& .MuiListItem-root": {
        width: "100%",
        color: white.main,
        "& .MuiListItemIcon-root": {
          color: white.main + " !important"
        },
        "& svg": {
          color: white.main + " !important"
        },
        "& .arrow-icon": {
          color: white.main
        }
      },

      "& .MuiListItemButton-root": {
        width: "calc(100% - 16px) !important",
        padding: "8px 12px !important",
        margin: "4px 8px !important",
        borderRadius: "10px !important",
        minHeight: "44px !important",
        transition: "background-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease"
      },

      "& .MuiListItem-root:hover": {
        width: "100%",
        backgroundColor: "rgba(6, 172, 236, 0.12)",
        color: "#18367A",
        "& .MuiListItemIcon-root": {
          color: "#18367A !important"
        },
        "& svg": {
          color: "#18367A !important"
        },
        "& .arrow-icon": {
          color: "#18367A"
        }
      },

      "& .Mui-selected, & .Mui-selected:hover": {
        background: "linear-gradient(90deg, #53B0E0, #2D2EAA) !important",
        color: white.main,
        boxShadow: "0 4px 12px rgba(24, 54, 122, 0.25)",
        "& .MuiListItemIcon-root": {
          color: white.main + " !important"
        },
        "& svg": {
          color: white.main + " !important"
        },
        "& .arrow-icon": {
          color: white.main
        }
      }
    }
  };
});